// extracted by mini-css-extract-plugin
module.exports = {"bookNowWrapper":"BookNow_bookNowWrapper__oVoIu","bookNowHotelName":"BookNow_bookNowHotelName__tiB83"};